<!-- ======= Header ======= -->
<header id="header" class="fixed-top d-flex align-items-center  header-transparent" style="background: rgba(42, 44, 57, 0.98);">
    <div class="container align-items-center">
        <div class="row">
            <div class="col-2">
                <div class="logo mr-auto animate__animated animate__faster animate__fadeInLeft">
                    <a><img src="assets/Logo.gif" alt="" class="img-fluid"></a>
                </div>
            </div>
            <div class="col-8">
                <div class="logo mr-auto text-center d-none d-sm-none d-md-block">
                    <!-- ======= Escritorio ======= -->
                    <h1 class="text-light animate__animated animate__faster animate__fadeInDown" style="font-size: 2rem;">
                        <a>Tu<span style="color: #ef6603;">Quiniela</span>Ya.web.app</a>
                    </h1>
                </div>
                <div class="logo mr-auto text-center d-block d-sm-block d-md-none">
                    <!-- ======= Movil ======= -->
                    <h1 class="text-light animate__animated animate__faster animate__fadeInDown" style="font-size: 2rem;">
                        <a>Tu<span style="color: #ef6603;">Quiniela</span>Ya</a>
                    </h1>
                </div>
            </div>
            <div class="col-2">
                <div id="menu" *ngIf="quiniela.url == 'adh'" class="logo text-right animate__animated animate__faster animate__fadeInRight">
                    <img src="assets/img/Logo_ADH.png" class="img-fluid">
                </div>
                <!-- .nav-menu -->
            </div>
        </div>
    </div>
</header>
<!-- End Header -->